import { render, staticRenderFns } from "./formSub.vue?vue&type=template&id=0a02b81e&scoped=true&"
import script from "./formSub.vue?vue&type=script&lang=js&"
export * from "./formSub.vue?vue&type=script&lang=js&"
import style0 from "./formSub.vue?vue&type=style&index=0&id=0a02b81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02b81e",
  null
  
)

export default component.exports